﻿import $ from 'jquery';

declare global {
  interface JQuery {
    disable(shouldClearValue?: boolean): JQuery;
    enable(): JQuery;
    isDisabled(): boolean;
    isEnabled(): boolean;
    toggleEnabled(condition: boolean, shouldClearValueOnDisable?: boolean): JQuery
  }
}

(function ($) {
  $.fn.disable = function (shouldClearValue: boolean = false) {
    $(this).each(function () {
      var $self = $(this);
      $self.attr('disabled', 'disabled');
      if (shouldClearValue)
        $self.val(null);
    });
    return $(this);
  };
  $.fn.enable = function () {
    $(this).each(function () {
      var $self = $(this);

      var disabledByPermissions = $self.data('disabled-by-permissions') || false;
      if (disabledByPermissions)
        return;

      $self.removeAttr('disabled');
    });
    return $(this);
  };
  $.fn.isDisabled = function () {
    return $(this).is('[disabled]');
  }
  $.fn.isEnabled = function () {
    return !$(this).isDisabled();
  }
  $.fn.toggleEnabled = function (condition, shouldClearValueOnDisable: boolean = false) {
    if (condition)
      return $(this).enable();
    else
      return $(this).disable(shouldClearValueOnDisable);
  }

  $(document).on('click.rustig.disable', 'a[disabled]', function (e) { e.preventDefault(); });
})($);
